"use client";

import { useState, useEffect, useCallback } from "react";
import { Search } from "lucide-react";
import dynamic from "next/dynamic";

const SearchModal = dynamic(() => import("./search-modal").then((module) => module.SearchModal), { ssr: false });

export function SearchButton() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((o) => !o), []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        toggle();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [toggle]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="text-neutral-400 transition-colors hover:text-acid"
        aria-label="Search"
      >
        <Search className="h-4 w-4" />
      </button>
      {open && <SearchModal onClose={() => setOpen(false)} />}
    </>
  );
}
